class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
/* === G&G Remove — tiny block === */
async function ggRefreshCartUI(){
  const r=await fetch('/?sections=cart-drawer,cart-icon-bubble',{headers:{Accept:'application/json'}}),
        j=await r.json(),
        d=document.querySelector('#CartDrawer, cart-drawer, .cart-drawer'),
        b=document.querySelector('cart-icon-bubble,.cart-count-bubble,[data-cart-count-bubble]');
  if(d && j['cart-drawer']) d.innerHTML=j['cart-drawer'];
  if(b && j['cart-icon-bubble']) b.outerHTML=j['cart-icon-bubble'];
  if(typeof ggAddRemoveButtons==='function') ggAddRemoveButtons();
}
function ggAddRemoveButtons(){
  const drawer=document.querySelector('#CartDrawer, cart-drawer, .cart-drawer'); if(!drawer) return;
  drawer.querySelectorAll('.cart-item,[data-cart-item]').forEach((item,i)=>{
    if(item.querySelector('.cart-item__remove')) return;
    const wrap=item.querySelector('.quantity')||item.querySelector('[data-quantity-wrapper]')||item;
    const btn=document.createElement('button'); btn.type='button'; btn.className='cart-item__remove'; btn.textContent='Remove'; btn.dataset.line=String(i+1);
    wrap.insertAdjacentElement('afterend',btn);
  });
}
function ggBindRemoveHandler(){
  document.addEventListener('click',async(e)=>{
    const el=e.target; if(!(el instanceof Element)) return;
    if(!el.classList.contains('cart-item__remove')) return;
    e.preventDefault();
    const line=Number(el.dataset.line||'1');
    try{
      await (await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({line,quantity:0})})).json();
      await ggRefreshCartUI();
    }catch(err){ console.error('Remove failed',err); location.reload(); }
  });
}
function ggInit(){ ggAddRemoveButtons(); ggBindRemoveHandler();
  ['cart:updated','cart:drawer:open','cart:drawer:render'].forEach(evt=>document.addEventListener(evt,ggAddRemoveButtons));
  const d=document.querySelector('#CartDrawer, cart-drawer, .cart-drawer');
  if(d && 'MutationObserver' in window) new MutationObserver(ggAddRemoveButtons).observe(d,{childList:true,subtree:true});
}
try{ ggInit(); }catch(e){ console.error(e); }
/* === end tiny block === */
